(ns com.theplantscape.plant-web.routes
  (:require
   [com.theplantscape.plant-web.draw.state]
   [com.theplantscape.plant-web.pages.diagram.view :refer [ui-page-diagram ui-head-diagram]]
   [com.theplantscape.plant-web.pages.diagram.list :as diagram #_#_:refer [page-diagrams]]
   [com.theplantscape.plant-web.pages.login :refer [login-page logout-page]]
   [com.theplantscape.plant-web.pages.profile :refer [profile-page]]
   [com.theplantscape.plant-web.pages.main :refer [init-main-page page-homepage] :as main-page]
   [com.theplantscape.plant-web.pages.plant-calendar
    :refer [ui-page-schedule]]
   [com.theplantscape.plant-web.pages.plant-layouts]
   [com.theplantscape.plant-web.pages.plants :refer [ui-page-plant-add]]
   [com.theplantscape.plant-web.pages.polyculture
    :refer [ui-page-polyculture ui-page-polycultures]]
   [reitit.frontend :as rf]))


(def router
  (rf/router
   [["/"
     {:name :homepage
      :state init-main-page
      :head main-page/head
      :view page-homepage}]
    ["/diagrams"
     {:name :diagrams
      :state diagram/diagram-list
      :view diagram/page-diagrams}]
    ["/diagram/{id}"
     {:name :diagram
      :parameters {:path {:id uuid?}}
      :state diagram/load-diagram
      :head ui-head-diagram
      :view ui-page-diagram}]
    ["/register"
     {:name :register
      :state com.theplantscape.plant-web.pages.login/init-registration
      :view com.theplantscape.plant-web.pages.login/register-new-user-page}]
    ["/login"
     {:name :login
      :state com.theplantscape.plant-web.pages.login/init-login
      :view com.theplantscape.plant-web.pages.login/login-page}]
    ["/user/profile"
     {:name :route-user-profile
      :state com.theplantscape.plant-web.pages.profile/init-profile-page
      :view  com.theplantscape.plant-web.pages.profile/profile-page}]
    ["/user/reset-password"
     {:name :route-forgot-password
      :state com.theplantscape.plant-web.pages.login/init-registration
      :view com.theplantscape.plant-web.pages.login/reset-password-page}]
    ["/logout"
     {:name :logout
      :view com.theplantscape.plant-web.pages.login/logout-page}]
    ["/polycultures"
     {:name :polycultures
      :state com.theplantscape.plant-web.pages.polyculture/init-polycultures-page
      :view ui-page-polycultures}]
    ["/polyculture/:id"
     {:name :polyculture
      :parameters {:path {:id uuid?}}
      :state com.theplantscape.plant-web.pages.polyculture/init-polyculture-page
      :view ui-page-polyculture #_(fn [p] (ui-page-polyculture p))}]
    ["/schedule/{diagram-id}"
     {:name :schedule
      :state com.theplantscape.plant-web.pages.plant-calendar/init-calendar-page
      :parameters {:path {:diagram-id uuid?}}
      :view com.theplantscape.plant-web.pages.plant-calendar/ui-page-schedule}]
    ["/plant/lists"
     {:name :plant-lists
      :view 'plant-lists}]
    ["/plant/list/{list}"
     {:name :plant-list
      :parameters {:path {:id uuid?}}
      :view 'plant-list}]
    ["/plant/add"
     {:name :plant-add
      :state com.theplantscape.plant-web.draw.state/reset-selected-plant
      :view ui-page-plant-add}]
    ["/plant/edit/:id"
     {:name :plant-edit
      :parameters {:path {:id uuid?}}
      :state com.theplantscape.plant-web.pages.plant-layouts/change-plant
      :view ui-page-plant-add}]
    ["/plant/search/"
     {:name :plant-search
      :view com.theplantscape.plant-web.pages.plants/ui-page-search-plant}]
    ["/plant/latest/:plant-id"
     {:name :plant
      :state com.theplantscape.plant-web.pages.plant-layouts/change-plant
      :parameters {:path {:plant-id uuid?}}
      :view com.theplantscape.plant-web.pages.plants/ui-page-search-plant #_'plant}]
    ["/plant/revision/{plant-id}/{revision}"
     {:name :plant-revision
      :parameters {:path {:id uuid? :version int?}}
      :state com.theplantscape.plant-web.pages.plant-layouts/change-plant
      :view com.theplantscape.plant-web.pages.plants/ui-page-search-plant #_'plant}]
    ["/settings"
     {:name :settings
      :view 'settings-page}]]))
